import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.js'
import zh_cn from './zh_cn.js'
import zh_tw from './zh_tw.js'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh_cn',
  missingWarn: false,
  fallbackWarn: false,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  messages: {
    en,
    zh_cn,
    zh_tw,
  },
})

export default i18n